import iso from "iso-3166-1";

import { BasketItem, ProductItem, Style } from "@is/types";

const MIN_POS_RESOLUTION = 1100;
const MAX_POS_RESOLUTION = 1300;
const POS_RATIO = 1.5;

export function convertFromStyleToProductItem(
  style: Style,
  ean?: string
): ProductItem {
  const selectedColorVariant = ean
    ? style.variants.find((variant) =>
        variant?.sizeInfos?.some((sizeInfo) => sizeInfo.ean === ean)
      ) || style.variants[0]
    : style.variants[0];

  const preselectedSize = selectedColorVariant?.sizeInfos?.find(
    (sizeInfo) => sizeInfo.ean === ean
  );

  return {
    styleId: style.id,
    id: selectedColorVariant?.id,
    name: style.name,
    color: selectedColorVariant?.color.name,
    media: style.media ? style.media : selectedColorVariant?.media,
    price: {
      currencyCode: selectedColorVariant?.prices?.length
        ? selectedColorVariant?.prices[0].currencyCode
        : null,
      retailPrice: selectedColorVariant?.prices?.length
        ? selectedColorVariant?.prices[0].retailPrice
        : null,
    },
    preselectedSize,
    styleDetails: style,
    isPDPOpen: true,
    isWidgetsOpen: true,
  };
}

export const convertCountryCodeToCountryName = (countryCode: string) => {
  if (!countryCode) {
    return "";
  }

  if (countryCode.length === 2) {
    return iso.whereAlpha2(countryCode)?.country || "";
  }

  return iso.whereAlpha3(countryCode)?.country;
};

export const convertAlpha3ToAlpha2 = (alpha3: string) =>
  iso.whereAlpha3(alpha3)?.alpha2 || "";

export const convertBasketItemToProductItem = (
  item: BasketItem
): ProductItem => ({
  styleId: item.productId,
  id: item.variantId,
  name: item.productName,
  price: item.price,
  media: [item.media],
  color: item.colorName,
  isPDPOpen: true,
  isWidgetsOpen: true,
});

export const convertSizeBasedOnResolution = (size: number) => {
  const windowWidth = window.innerWidth;

  const posResolution =
    windowWidth > MIN_POS_RESOLUTION && windowWidth < MAX_POS_RESOLUTION;

  return posResolution ? Math.round((size / POS_RATIO) * 100) / 100 : size;
};
